<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">ABOUT</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">CIEPEC2026 information</el-menu-item>
            <el-menu-item index="2">Expo Profile</el-menu-item>
            <el-menu-item index="4">Review</el-menu-item>
            <!-- <el-menu-item index="3">Organization</el-menu-item> -->
            <el-menu-item index="5"> Floor plan</el-menu-item>
          </el-menu>
          <div class="zcsj">
            Exhibit Hours
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 2, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 3, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 4, 2026, 9:00am-4:00pm
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              (Last admission 1 hour before closing)
            </div>
          </div>
        </el-col>
        <el-col :span="18">

          <div v-if="menuName=='CIEPEC2026 information'||pageNum==1">
            <!-- <img style="margin-left:40px;margin-top:20px" src="../../assets/index/table.png" alt=""> -->
            <div class="zhzl">
              Date:
            </div>
            <div class="zhzltext">
              CIEPEC2026 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 - 4 June 2026
            </div>
            <div class="zhzl">
              Opening Hours
            </div>
            <div class="zhzltext">
              2 June 2026 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9:00am – 5:00pm
            </div>
            <div class="zhzltext">
              3 June 2026 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9:00am – 5:00pm
            </div>
            <div class="zhzltext">
              4 June 2026 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9:00am – 4:00pm
            </div>
            <img style="width:100%" src="../../assets/index/附件五.jpg" alt="">
          </div>
          <div style="padding:0 30px" v-if="menuName=='Expo Profile'||pageNum==2">
            <img style="width:100%" src="../../assets/index/附件七.jpg" alt="">
          </div>
          <!-- <div style="padding:0 30px" v-if="menuName=='Organization'||pageNum==3">
            <div class="organization-section">
              <h3>Organization</h3>
              <div class="org-table">
                <div class="org-row org-header">
                  <div class="org-cell">Organizer:</div>
                  <div class="org-cell">China Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row org-header">
                  <div class="org-cell">Partners: Government Agencies</div>
                  <div class="org-cell"></div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Trade Development Bureau of the Ministry of Commerce</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Environmental Protection Department The Government of the Hong Kong Special Administrative Region</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Environmental Protection Department The Government of the Macao Special Administrative Region</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Ministry of Environment, Republic of Korea</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">KOREA TRADE-INVESTMENT PROMOTION AGENCY</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">INNOVATION NORWAY</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Royal Norwegian Embassy in Beijing</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Italian Trade Agency Beijing Office</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">British Department for International Trade</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Embassy of Canada in Beijing</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">U.S. Commercial Service, Embassy of the United States of America</div>
                </div>
                <div class="org-row org-header">
                  <div class="org-cell">Institutions Affiliated to MEE</div>
                  <div class="org-cell"></div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Chinese Research Academy of Environmental Sciences</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China National Environmental Monitoring Centre</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Environmental Development Center of the Ministry of Ecology and Environment</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Policy Research Center for Environment and Economy, Ministry of Ecology and Environment of the People's Republic of China</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Environmental News</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Foreign Economic Cooperation Center, Ministry of Ecology and Environment (FECO)</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Nanjing Institute of Environmental Sciences of the Ministry of Environmental Protection (NIES)</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">South China Institute of Environmental Sciences (SCIES)</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Chinese Academy of Environmental Planning</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Appraisal Center for Environment and Engineering, Ministry of Ecology and Environment</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Satellite Application Center for Ecology and Environment, MEE</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Solid Waste and Chemicals Management Center, MEE</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Technical Centre for Soil, Agriculture and Rural Ecology and Environment, Ministry of Ecology and Environment</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Center for Environmental Education and Communications of Ministry of Ecology and Environment</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Environmental Protection Foundation</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Ecological Civilization Research and Promotion Association</div>
                </div>
                <div class="org-row org-header">
                  <div class="org-cell">Industry Organizations</div>
                  <div class="org-cell"></div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Petroleum and Chemical Industry Federation</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Building Materials Federation</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Iron and Steel Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Mining Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China International Contractors Association (CHINCA)</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Resource Recycling Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Chemical Industry Environmental Protection Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Coking Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Animal Agriculture Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Surface Engineering Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Foundry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Overseas Development Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Association for Small & Medium Commercial Enterprises</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">The Chinese Ceramic Society</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Association of Construction Education</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Association of Machinery Industry for Environmental Protection</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Electricity Council</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Nuclear Industry Exploration & Design</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">ChinaWood Protection Industry Association, CWPIA</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Customs Brokers Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Chinese Health Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">China Electronmental Energy Saving Technology Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Korea Environmental Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Norwegian Energy and Environment Consortium (NEEC)</div>
                </div>
                <div class="org-row org-header">
                  <div class="org-cell">Local Environmental Protection Industry Associations</div>
                  <div class="org-cell"></div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Beijing Association of Environment Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Tainjin Association of Environment Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Hebei Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shanxi Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Inner Mongolia Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Liaoning Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Jilin Environmental Protection Industy Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Heilongjiang Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shanghai Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Jiangsu Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Zhejiang Province Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Anhui Environmental Protection lndustry Network</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Fujian Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Jiangxi Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shandong Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">HENAN ENVIRONMENTAL PROTECTION INDUSTRY ASSOCIATION</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Hubei Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Hunan Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Guangdong Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Guangxi Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Chongqing Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Sichuan Provincial Association Of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Guizhou Provincial Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Yunnan Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shaanxi Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">GanSuAssociationofEnvironmentalProtectionIndustry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Qinghai Province Association of Environmental protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Ningxia Association of Environmental Protection Industrial</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Xinjiang Uygur Autonomous Region Ecological Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">XPCC Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Guangzhou Association of Environmental Protection Industrial</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Wuhan Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Haerbin Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shenyang Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Chengdu Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Nanjing Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Xian Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Changchun Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Hangzhou Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Shenzhen Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Xiamen Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Ningbo Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Qingdao Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Dalian Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Hohhot Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Suzhou Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Changzhou Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Taizhou Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Nantong Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Baiyin Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Yixing Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Mianyang Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Foshan Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Langfang Environmental Protection Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Sanmenxia Association of Environmental Protection Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Yixing Green & Low-carbon Industry Association</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Southern China Cluster of State Environment Service Industry</div>
                </div>
                <div class="org-row">
                  <div class="org-cell"></div>
                  <div class="org-cell">Jiangsu Yancheng Environmental Protection Technology City</div>
                </div>
              </div>
            </div>
          </div> -->
          <div style="padding:0 30px" v-if="menuName=='Floor plan'||pageNum==5">
            <img style="width:100%" src="../../assets/index/英文版平面图.png" alt="">

          </div>
          <div style="padding:0 30px" v-if="menuName=='Review'||pageNum==4">
            <img style="width:100%" src="../../assets/index/附件六.jpg" alt="">

          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   data: String,
  //   nametitle: String
  // },
  props: ['data', 'nametitle'],
  watch: {
    // 监听 data 的变化
    data (newValue, oldValue) {
      this.pageNum = newValue
    },
    nametitle (newValue, oldValue) {
      this.menuName = newValue
    }
  },
  name: 'Gyzh',
  data () {
    return {
      menuName: '展会总览',
      pageNum: '1',
      list: [{
        images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/1.jpg',
        title: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函',
        content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/2.png',
        time: '2023-09-06',
        type: 'image',
        abstract: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函'
      }]
    }
  },
  beforeDestroy () {
    // this.pageNum = '1'
    // this.menuName = '展会总览'

  },
  destroyed () {

  },
  mounted () {
    if (this.data) {
      this.pageNum = this.data
      this.menuName = this.nametitle
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      console.log(key)
      window.translate.execute()
    },
    xzwzhandle (item) {
      // this.$router.push({ path: '/caidan/xwzx', query: { pageNum: 'xq', wzcont: item } })
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  background-image: url('../../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: 40% 100%;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 24px;
  font-weight: 700;
  margin: 20px 40px 10px;
  line-height: 40px;
  border: 1px solid #ccc;
  padding: 8px 15px;
  background-color: #f9f9f9;
}
.zhzltext {
  font-size: 18px;
  font-weight: 400;
  margin: 5px 40px 8px;
  line-height: 32px;
  border: 1px solid #ccc;
  padding: 8px 15px;
  display: flex;
  justify-content: space-between;
}
.zhlc {
  font-size: 18px;
  font-weight: normal;
  margin: 10px 30px;
  line-height: 40px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}
/* Organization表格样式 */
.organization-section {
  margin: 20px 0;
}

.organization-section h3 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 40px 20px;
  color: #333;
}

.org-table {
  margin: 0 40px;
}

.org-row {
  display: flex;
  border: 1px solid #ccc;
  padding: 8px 15px;
  font-size: 18px;
  line-height: 28px;
}

.org-header {
  background-color: #f9f9f9;
  font-weight: bold;
}

.org-cell {
  flex: 1;
}

.org-cell:first-child {
  flex: 0 0 300px;
  font-weight: bold;
}

.org-row .org-cell:first-child {
  border-right: 1px solid #ccc;
  padding-right: 15px;
  margin-right: 15px;
}

.org-row .org-cell:last-child {
  flex: 1;
}

/* 空单元格的样式 */
.org-row:not(.org-header) .org-cell:first-child {
  border-right: none;
  padding-right: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/caidaneng/gyzh.vue